import { ComponentProps } from 'react';
import { cn } from 'utils/cn';

/** A full-width block that scrolls its content horizontally instead of overflowing. */
export default function ScrollX({ className, ...props }: ComponentProps<'div'>) {
    return <div className={cn('block w-full overflow-x-auto', className)} {...props} />;
}
